import { Link } from "react-router-dom";
import type { Collection } from "../data/collections";
import { JewelleryMotif } from "./JewelleryMotif";

export function CollectionCard({ collection }: { collection: Collection }) {
  return (
    <Link className="product-tile" to={`/collections/${collection.slug}`}>
      <div className="vitrine">
        <JewelleryMotif motif={collection.motif} title={collection.name} />
      </div>
      <div className="product-copy">
        <span className="coming-soon-flag">Coming soon</span>
        <h3>{collection.name}</h3>
        <p className="muted">{collection.intro}</p>
      </div>
    </Link>
  );
}
